import React from 'react';
import { Box, List, ListItem, MenuItem, Select, Typography, useTheme } from '@mui/material';
import FilledTickIcon from '../../icons/FilledTickIcon';
import RoundRingIcon from '../../icons/RoundRingIcon';
import { DetailsIconBox } from './style';
import { KeyboardArrowDown } from '@mui/icons-material';
import { post } from '../../api';

function TodoTasks({ todoItemList = [], currentSelectedItem, selectedItemDetails, updateTaskStatus }) {
    const handleTodoList = (currentCheckItem, newStatus) => {
        let newItem = { ...currentCheckItem, status: newStatus };
        updateTaskStatus(todoItemList.map((item) => (item.id === newItem.id ? newItem : item)));
        post('custom/updateCompanyTasksStatus', { recordId: newItem.id, status: newStatus });
    };

    const theme = useTheme();

    if (todoItemList.length === 0) {
        return null;
    }

    return (
        <Box margin={`${theme.typography.generic.xxxxxLarge} ${theme.typography.generic.xxLarge}`}>
            <Typography component={'h3'} variant="paraText6" color={'text.secondary'}>
                {todoItemList?.length === 1 ? 'Related company' : 'Related companies'}
            </Typography>
            <Box sx={{ mt: '0px !important', ml: '0px !important' }} component={List} display={'flex'} flexDirection={'column'} gap={'0.5rem'}>
                {[...todoItemList]
                    .sort((a, b) => a.companyName.localeCompare(b.companyName))
                    .map((cItem) => (
                        <ListItem
                            key={cItem.id}
                            sx={{
                                border: `1px solid ${theme.palette.border.neutralPrimary}`,
                                borderRadius: theme.typography.borderRadius.medium,
                                padding: `${theme.typography.generic.xLarge}`,

                                display: 'flex',
                                justifyContent: 'space-between',
                                mt: '0px !important',
                                ml: '0px !important',
                            }}
                        >
                            <Box
                                sx={{
                                    width: '50%',
                                    minWidth: '50%',

                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    alignItems: 'center',
                                }}
                            >
                                {/* {getDetailsTag(cItem)} */}
                                <Typography component={'p'} variant="paraText2" color={'text.secondary'} ml={1}>
                                    {cItem.companyName}
                                </Typography>
                            </Box>
                            {/* <Select
                                value={cItem.status}
                                onChange={(e) => {
                                    handleTodoList(cItem, e.target.value);
                                }}
                                IconComponent={KeyboardArrowDown}
                                inputProps={{ 'aria-label': 'Task Status' }}
                                sx={{
                                    minWidth: '7rem',

                                    '& .MuiSelect-select.MuiSelect-outlined': {
                                        padding: `${theme.typography.generic.none} ${theme.typography.generic.xSmall}`,
                                        fontSize: theme.typography.customFontSize.small,
                                        fontWeight: theme.typography.fontWeightSemiBold,
                                        borderRadius: theme.typography.borderRadius.xxSmall,

                                        // color:
                                        //     cItem.status === 'Completed'
                                        //         ? theme.palette.primary.main
                                        //         : cItem.status === 'In Progress'
                                        //           ? theme.palette.text.statusWarning
                                        //           : cItem.status === 'Not Started'
                                        //             ? theme.palette.text.tertiary
                                        //             : '',
                                        color: 'gray.700',
                                    },
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        border: `none`,
                                    },

                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: `${theme.palette.secondary.main}`,
                                    },

                                    '& .MuiSvgIcon-root': {
                                        color: 'gray.500',
                                    },
                                }}
                                MenuProps={{
                                    sx: {
                                        '& .MuiMenuItem-root': {
                                            color: 'text.secondary',
                                        },
                                    },
                                }}
                            >
                                <MenuItem value="Completed">Completed</MenuItem>
                                <MenuItem value="In Progress">In Progress</MenuItem>
                                <MenuItem value="Not Started">Not Started</MenuItem>
                            </Select> */}
                        </ListItem>
                    ))}
            </Box>
        </Box>
    );
}

export default TodoTasks;
